module.exports = __webpack_public_path__ + "img/gift4-01-c06-k2.5a1deef5.png";